namespace CMS {

    const observable = 'IntersectionObserver' in window;

    class CmsComponent {
        pageId : string;
        componentName : string;
        componentId : string;
        inView: boolean;
        lazy: boolean;
        url():string {
            if(!this.inView && this.lazy && observable) {
                return 'loadingcmscomponent.html';
            }
            if(this.componentId) {
                return `cms/component/${this.pageId}/${this.componentId}`;
            } else if(this.componentName) {
                return `cms/component/${this.pageId}/${this.componentName}`;
            } else if(this.pageId) {
                return `cms/component/${this.pageId}`;
            } else {
                return `cms/missing`;
            }
        }
        modal : any;
        rc : any;
    }

    angular.module('cms').directive('lazyCms', () => {
        return {
            restrict: 'A',
            require: '^cmsComponent',
            link: (scope, el, attr, controller: CmsComponent) => {
                if (!observable || !controller.lazy) {
                    return;
                }
                const observer = new IntersectionObserver(loadContent, {
                    rootMargin: '200px 0px 200px 0px'
                });
                observer.observe(el[0]);
                function loadContent(changes) {
                    changes.forEach(function (change) {
                        if (change.intersectionRatio > 0) {
                            observer.unobserve(change.target);
                            scope.$apply(() => controller.inView = true);
                        }
                    });
                }
            }
        };
    });

    /*
    The lazy attribute controls whether this component will be loaded lazily based on whether it is
    visible in the viewport
     */
    angular.module('cms').directive('cmsComponent', function($timeout) {
        return {
            scope: {},
            replace: true,
            bindToController: {
                data: '=',
                pageId: '@',
                componentName: '@',
                componentId: '@',
                lazy: '<'
            },
            controller: CmsComponent,
            controllerAs: 'cc',
            template: '<span lazy-cms ng-include="cc.url()"></span>',
            link: function(scope: ng.IScope, el, attr, controller: CmsComponent) {
                let p:any = scope.$parent;
                while (p != null) {
                    if (p['rc'] != null) {
                        controller.modal = p['rc'].modal;
                        controller.rc = p['rc'];
                        p = null;
                    } else {
                        p = p.$parent;
                    }
                }
            }
        };
    });
}
